import React, { PropsWithChildren, memo, useMemo } from 'react';
import Span from '../Span';
import classNames from 'classnames';

export type TagProps = {
  className?: string;
  dataTestId?: string;
  label?: string;
  type?: string;
  color: 'Red' | 'Green' | 'Blue' | 'Yellow'; // Restrict color to specific values
  colorClassName?: string;
};

const Metadata = {
  Red: 'text-red-500 bg-red-200  border-red-400 ',
  Green: 'text-green-500 bg-green-200 border-green-400 ',
  Blue: 'text-blue-500 bg-blue-200  border-blue-400 ',
  Yellow: 'text-yellow-500 bg-yellow-200  border-yellow-400 ',
};

const Tag = {
  Red: 'bg-red-600',
  Green: 'bg-green-600',
  Blue: 'bg-blue-600',
  Yellow: 'bg-extended-newGold',
};

function MetadataTag({
  className,
  dataTestId,
  label = '',
  type,
  color,
  colorClassName,
  ...restProps
}: PropsWithChildren<TagProps>) {
  let css = useMemo(() => {
    if (type === 'Tag') {
      const tagColor = colorClassName ? colorClassName : Tag[color];
      return (
        tagColor +
        ' text-white text-body-xs md:text-body-xs-desktop px-s3 py-s2 rounded-cxxs uppercase'
      );
    } else {
      return (
        Metadata[color] +
        ' text-body-sm md:text-body-sm-desktop px-s3 py-s1 border rounded-cxxs bg-opacity-20 border-opacity-50'
      );
    }
  }, [color, type, colorClassName]);

  return (
    <Span className={classNames('h-fit', css, className)} dataTestId={dataTestId} {...restProps}>
      {label}
    </Span>
  );
}

export default MetadataTag;
